export default __webpack_public_path__ + "static/media/1840.75adee45.png";